import React, { Fragment } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// REDUX
import { connect } from 'react-redux';
import { saveCustomerInfo } from '../../store/actions/AuthAction';
import 'react-notifications-component/dist/theme.css';
import '../../assets/styles/animate.min.css';
import '../../assets/styles/longdh.css';

import { handleLogoutCookie } from '../utils/cookies';

import NavbarPermission from './MenuPermission';
import { removeCookieNotion } from '../utils/cookiesLink';

const menus = [
    { Id: 1, name: 'Chi nhánh', path: '/stores', icon: 'mdi mdi-account-box' },
    {
        Id: 2,
        name: 'Đối tác',
        path: '/g-customers',
        icon: 'mdi mdi-account-multiple-outline',
        subMenus: [
            { name: 'Khách hàng', path: '/customers', icon: 'mdi mdi-account-multiple-outline' },
            { name: 'Nhà cung cấp', path: '/providers', icon: 'mdi mdi-account-multiple-outline' },
        ],
    },
    {
        Id: 3,
        name: 'Sản phẩm',
        path: '/g-products',
        icon: 'mdi mdi-account-settings',
        subMenus: [
            { name: 'Danh mục', path: '/category', icon: 'mdi mdi-account-box' },
            { name: 'Sản phẩm', path: '/products', icon: 'mdi mdi-account-box' },
            { name: 'Đơn vị tính', path: '/unit-manger', icon: 'mdi mdi-account-box' },
            { name: 'Lô hàng', path: '/shipment-manger', icon: 'mdi mdi-account-box' },
        ],
    },

    {
        Id: 4,
        name: 'Kho hàng',
        path: '/g-warehouse',
        icon: 'mdi mdi-account-settings',
        subMenus: [
            { name: 'Nhập hàng', path: '/goodReceived', icon: 'mdi mdi-account-box' },
            { name: 'Chuyển hàng', path: '/shipping-management', icon: 'mdi mdi-account-box' },
            { name: 'Trả hàng nhập', path: '/merchandiseReturned', icon: 'mdi mdi-account-box' },
            { name: 'Kiểm kho', path: '/inventory', icon: 'mdi mdi-account-box' },
        ],
    },
    {
        Id: 5,
        name: 'Báo cáo',
        path: '/g-reports',
        icon: 'mdi mdi-checkbox-blank-outline',
        subMenus: [{ name: 'Báo cáo theo lô và HSD', path: '/batch-expiry-date-report', icon: 'mdi mdi-account-box' }],
    },
    { Id: 8, name: 'Sổ quỹ Retail', path: '/cashBookRetail', icon: 'mdi mdi-image-album' },
    {
        Id: 9,
        name: 'Cấu hình hệ thống',
        path: '/g-config',
        icon: 'mdi mdi-settings-box',
        subMenus: [
            { name: 'Cấu hình thời gian trả hàng', path: '/config-time-delivery', icon: 'mdi mdi-av-timer' },
            { name: 'Cấu hình các loại phí', path: '/config-fees', icon: 'mdi mdi-cash-multiple' },
            { name: 'Cấu hình chính sách khuyến mại', path: '/sale-program', icon: 'mdi mdi-gift' },
        ],
    },
];

function Navbars(props) {
    const openSecondScreen = () => {
        window.open(process.env.REACT_APP_URL + 'customer-order')
    }
    return (
        <div className='top-navbar-menu' id='navbar'>
            <NavbarPermission token={props.token}>
                <div className='info-user user uln posR flr'>
                    <a className='nav-link dpib userName' href='#'>
                        <span>{props.username}</span>
                        <i className='mdi mdi-account-circle ml-2'></i>
                    </a>
                    <ul ng-show='showUserMenu'>
                        <li>
                            <a className='nav-link' href='#'>
                                <i className='mdi mdi-account-circle mr-2'></i> Tài khoản
                            </a>
                        </li>
                        <li>
                            <a className='nav-link' href='#' onClick={openSecondScreen}>
                                <i className='mdi mdi-vector-arrange-above mr-2'></i> Màn hình phụ
                            </a>
                        </li>
                        <li>
                            <a className='nav-link' href='/config-printer'>
                                <i className='mdi mdi-printer mr-2'></i> Cấu hình máy in
                            </a>
                        </li>
                        <li>
                            <a
                                className='nav-link'
                                onClick={() => {
                                    props.saveCustomerInfo({ token: '', fullName: '' });
                                    handleLogoutCookie();
                                    removeCookieNotion();
                                    window.location.href=process.env.REACT_APP_LINK_WEB_LOGIN;
                                }}
                            >
                                <i className='mdi mdi-logout mr-2'></i> Đăng xuất
                            </a>
                        </li>
                    </ul>
                </div>
            </NavbarPermission>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        token: state.authReducer.detail.token,
        username: state.authReducer.detail.username,
        role: state.authReducer.detail.role,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveCustomerInfo: (data) => dispatch(saveCustomerInfo(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbars);
